import { createContext, FC, useState } from "react";

export const NewVersionContext = createContext({
  isVersionModalVisible: false,
  changeVersionAlert: (isModalVisible: boolean, versionChannel?: BroadcastChannel) => {},
})



const NewVersionProvider: FC<{ children: JSX.Element }> = ({ children }): JSX.Element => {
  const [isVersionModalVisible, changeModalVisibility] = useState<boolean>(false);

  const updateVersion = (isModalVisible: boolean, versionChannel?: BroadcastChannel) => {
    changeModalVisibility(isModalVisible)
    if (!isModalVisible) {
      window.location.reload();
      versionChannel?.postMessage("new_version")
    }
  }

  return (
    <NewVersionContext.Provider value={{ isVersionModalVisible, changeVersionAlert: updateVersion }}>
      {children}
    </NewVersionContext.Provider>
  )
}

export default NewVersionProvider
